import { createStyles, makeStyles } from '@material-ui/core/styles';
const useMapDefaultStyles = makeStyles((theme) => createStyles({
    mapContainer: {
        width: '100%',
        flexGrow: 1,
    },
    buttonLayers: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        borderRadius: 24,
    },
    buttonsZoom: {
        position: 'absolute',
        right: theme.spacing(1),
        top: '50%',
        transform: 'translateY(-50%)',
    },
    buttonLocation: {
        position: 'absolute',
        right: theme.spacing(1),
        bottom: theme.spacing(1),
    },
    buttonEstate: {
        position: 'absolute',
        bottom: theme.spacing(1),
        left: theme.spacing(1),
    },
    locationMarker: {
        backgroundImage: `url(${require('./icons/location.svg')})`,
        backgroundSize: 'cover',
        width: 30,
        height: 30,
    },
}));
export default useMapDefaultStyles;
